// @flow
import React, { Component } from 'react';
import cx from 'classnames';
import Overlay from './Overlay';
import LoadingDiv from './LoadingDiv';

export default class LoadingScreen extends Component {
  render() {
    const { className, children, style, ...rest } = this.props;
    return (
      <Overlay style={style} className={cx('justify-content-center', className)}>
        <LoadingDiv {...rest}>{children}</LoadingDiv>
      </Overlay>
    );
  }
}